import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthenticatedComponent} from './authenticated.component';
import {AuthGuard} from '../../_guards/auth.guard';
import {PermissionsGuard} from '../../_guards/permissions.guard';
import {RouteGuard} from '../../_guards/route.guard';

const routes: Routes = [
    {
        path: '',
        component: AuthenticatedComponent,
        canActivate: [
            AuthGuard,
            RouteGuard
        ],
        canActivateChild: [
            PermissionsGuard
        ],
        children: [
            {
                path: 'vehicle-live-status',
                loadChildren: () => import('./vehcile-live-status/vehicle-live-status.module').then(m => m.VehicleLiveStatusModule)
            },
            {
                path: 'home',
                loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
            },
            {
                path: 'devices',
                loadChildren: () => import( './devices/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'device',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './devices/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'view/:device_id',
                        loadChildren: () => import( './devices/view/view.module').then(m => m.ViewModule)
                    },
                    {
                        path: 'update/:device_id',
                        loadChildren: () => import( './devices/update/update.module').then(m => m.UpdateModule)
                    }
                ],
            },
            {
                path: 'masking/:device_id',
                loadChildren: () => import( './device-masking/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'masking',
                children: [
                    {
                        path: 'add/:device_id',
                        loadChildren: () => import( './device-masking/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'view/:masking_id',
                        loadChildren: () => import( './device-masking/view/view.module').then(m => m.ViewModule)
                    },
                    {
                        path: 'update/:masking_id',
                        loadChildren: () => import( './device-masking/update/update.module').then(m => m.UpdateModule)
                    }
                ],
            },
            {
                path: 'device-events/:device_id',
                loadChildren: () => import( './device-events/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'vehicle-events',
                loadChildren: () => import( './vehicle-events/vehicle-events.module').then(m => m.VehicleEventsModule)
            },
            {
                path: 'device-event',
                children: [
                    {
                        path: 'add/:device_id',
                        loadChildren: () => import( './device-events/add/add.module').then(m => m.AddModule)
                    }
                ],
            },
            {
                path: 'alerts',
                loadChildren: () => import( './alerts/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'events',
                loadChildren: () => import( './events/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'event',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './events/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'view/:event_id',
                        loadChildren: () => import( './events/view/view.module').then(m => m.ViewModule)
                    },
                    {
                        path: 'update/:event_id',
                        loadChildren: () => import( './events/update/update.module').then(m => m.UpdateModule)
                    }
                ],
            },
            {
                path: 'all-assets',
                loadChildren: () => import( './assets/index/asset.module').then(m => m.AssetModule)
            },
            {
                path: 'asset',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './assets/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'view/:asset_id',
                        loadChildren: () => import( './assets/view/view.module').then(m => m.ViewModule)
                    },
                    {
                        path: 'reporting-configuration/:asset_id',
                        loadChildren: () => import( './assets/reporting-configuration/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'update/:asset_id',
                        loadChildren: () => import( './assets/update/update.module').then(m => m.UpdateModule)
                    }
                ],
            },
            {
                path: 'asset-groups',
                loadChildren: () => import( './assets-groups/index/asset.module').then(m => m.AssetModule)
            },
            {
                path: 'asset-group',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './assets-groups/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'view/:asset_id',
                        loadChildren: () => import( './assets-groups/view/view.module').then(m => m.ViewModule)
                    },
                    {
                        path: 'update/:asset_id',
                        loadChildren: () => import( './assets-groups/update/update.module').then(m => m.UpdateModule)
                    }
                ],
            },
            {
                path: 'roles',
                loadChildren: () => import( './roles/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'role',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './roles/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'update/:role_id',
                        loadChildren: () => import( './roles/update/update.module').then(m => m.UpdateModule)
                    },
                    {
                        path: 'view/:role_id',
                        loadChildren: () => import( './roles/view/view.module').then(m => m.ViewModule)
                    }
                ],
            },
            {
                path: 'users',
                loadChildren: () => import( './users/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'user',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './users/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'update/:user_id',
                        loadChildren: () => import( './users/update/update.module').then(m => m.UpdateModule)
                    },
                    {
                        path: 'view/:user_id',
                        loadChildren: () => import( './users/view/view.module').then(m => m.ViewModule)
                    }
                ],
            },
            {
                path: 'drivers',
                loadChildren: () => import( './drivers/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'driver',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './drivers/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'update/:id',
                        loadChildren: () => import( './drivers/update/update.module').then(m => m.UpdateModule)
                    },
                    {
                        path: 'view/:id',
                        loadChildren: () => import( './drivers/view/view.module').then(m => m.ViewModule)
                    }
                ],
            },
            {
                path: 'maintenance',
                children: [
                    {
                        path: 'index',
                        loadChildren: () => import( './maintenance/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'add',
                        loadChildren: () => import( './maintenance/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'update/:maintenance_id',
                        loadChildren: () => import( './maintenance/update/update.module').then(m => m.UpdateModule)
                    },
                    {
                        path: 'view/:maintenance_id',
                        loadChildren: () => import( './maintenance/view/view.module').then(m => m.ViewModule)
                    }
                ],
            },
            {
                path: 'maintenance-work-jobs',
                loadChildren: () => import( './maintenance-work-jobs/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'maintenance-work-job',
                children: [
                    {
                        path: 'view/:maintenance_work_job_id',
                        loadChildren: () => import( './maintenance-work-jobs/view/view.module').then(m => m.ViewModule)
                    }
                ],
            }
            , {
                path: 'poi',
                children: [
                    {
                        path: 'index',
                        loadChildren: () => import( './poi/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'add',
                        loadChildren: () => import( './poi/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'view/:poi_id',
                        loadChildren: () => import( './poi/view/view.module').then(m => m.ViewModule)
                    },
                    {
                        path: 'update/:poi_id',
                        loadChildren: () => import( './poi/update/update.module').then(m => m.UpdateModule)
                    }
                ],
            }, {
                path: 'zone',
                children: [
                    {
                        path: 'index',
                        loadChildren: () => import( './zone/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'add',
                        loadChildren: () => import( './zone/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'update/:zone_id',
                        loadChildren: () => import( './zone/update/update.module').then(m => m.UpdateModule)
                    },
                    {
                        path: 'view/:zone_id',
                        loadChildren: () => import( './zone/view/view.module').then(m => m.ViewModule)
                    }
                ],
            },
            {
                path: 'routes',
                loadChildren: () => import( './routes/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'route',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './routes/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'update/:route_id',
                        loadChildren: () => import( './routes/edit/edit.module').then(m => m.EditModule)
                    },
                    {
                        path: 'view/:route_id',
                        loadChildren: () => import( './routes/view/view.module').then(m => m.ViewModule)
                    }
                ],
            },
            {
                path: 'trips',
                loadChildren: () => import( './trips/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'trip',
                children: [
                    {
                        path: 'view/:trip_id',
                        loadChildren: () => import( './trips/view/view.module').then(m => m.ViewModule)
                    }
                ],
            },
            {
                path: 'trip/trip-type-a',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './trips/trip-type-a/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'update/:trip_id',
                        loadChildren: () => import( './trips/trip-type-a/update/update.module').then(m => m.UpdateModule)
                    },
                ],
            },
            {
                path: 'trip/trip-type-b',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './trips/trip-type-b/add/add.module').then(m => m.AddModule)
                    },
                ],
            },
            {
                path: 'trip/trip-type-c',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './trips/trip-type-c/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'view/:trip_id',
                        loadChildren: () => import( './trips/trip-type-c/view/view.module').then(m => m.ViewModule)
                    },
                ],
            },
            {
                path: 'trip/trip-type-d',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './trips/trip-type-d/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'print',
                        loadChildren: () => import( './trips/trip-type-d/print/print.module').then(m => m.PrintModule)
                    }
                ],
            },
            {
                path: 'fuel-fillings',
                loadChildren: () => import( './fuel-fillings/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'fuel-filling',
                children: [
                    {
                        path: 'add',
                        loadChildren: () => import( './fuel-fillings/add/add.module').then(m => m.AddModule)
                    },
                    {
                        path: 'view/:fuel_filling_id',
                        loadChildren: () => import( './fuel-fillings/view/view.module').then(m => m.ViewModule)
                    }
                ],
            },
            {
                path: 'mapping-keys',
                loadChildren: () => import( './MappingKey/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'reports',
                loadChildren: () => import( './reports/index/index.module').then(m => m.IndexModule)
            },
            {
                path: 'report',
                children: [
                    {
                        path: 'fuel-filling',
                        loadChildren: () => import( './fuel-filling-reports/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'movement',
                        loadChildren: () => import( './reports/movement/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'consolidated',
                        loadChildren: () => import( './reports/consolidated/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'geofence',
                        loadChildren: () => import( './reports/geofence/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'stop-over',
                        loadChildren: () => import( './reports/stop-over/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'over-speed',
                        loadChildren: () => import( './reports/over-speed/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'journey',
                        loadChildren: () => import( './reports/journey/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'idle',
                        loadChildren: () => import( './reports/idle/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'geofence-detail',
                        loadChildren: () => import( './reports/geofence-detail/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'working-hours',
                        loadChildren: () => import( './reports/working-hours/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'fleet-summary',
                        loadChildren: () => import( './reports/fleet-summary/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'driving-quality',
                        loadChildren: () => import( './reports/driving-quality/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'temperature-sensor',
                        loadChildren: () => import( './reports/temperature-sensor/index/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'consolidated',
                        loadChildren: () => import( './reports/consolidated/index/index.module').then(m => m.IndexModule)
                    }
                ],
            },
            {
                path: 'general-reports',
                loadChildren: () => import('./general-reports/index/index.module').then(m => m.IndexModule),
            },
            {
                path: 'general-report',
                children: [
                    {
                        path: 'consolidated',
                        loadChildren: () => import( './general-reports/consolidated/consolidated.module').then(m => m.ConsolidatedModule)
                    },
                    {
                        path: 'cumulative-consolidated-corporate',
                        loadChildren: () => import( './general-reports/cumulative-consolidated-corporate/cumulative-consolidated-corporate.module').then(m => m.CumulativeConsolidatedCorporateModule)
                    },
                    {
                        path: 'poi',
                        loadChildren: () => import( './general-reports/poi-visit-report/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'poi-stay-in',
                        loadChildren: () => import( './general-reports/poi-stay-in-report/poi-stay-in-report.module').then(m => m.PoiStayInReportModule)
                    },
                    {
                        path: 'nr',
                        loadChildren: () => import( './general-reports/nr/nr.module').then(m => m.NrModule)
                    },
                    {
                        path: 'stop-over',
                        loadChildren: () => import( './general-reports/stop-over/stop-over.module').then(m => m.StopOverModule)
                    },
                    {
                        path: 'over-speed',
                        loadChildren: () => import( './general-reports/over-speed/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'distance-with-fuel',
                        loadChildren: () => import( './general-reports/distance-with-fuel/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'excess-idle',
                        loadChildren: () => import( './general-reports/excess-idle-report/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'fuel-vehicle',
                        loadChildren: () => import( './general-reports/fuel-vehicle/fuel.vehicle.module').then(m => m.FuelVehicleModule)
                    },
                    {
                        path: 'continuous-driving',
                        loadChildren: () => import( './general-reports/continuous-driving/index.module').then(m => m.IndexModule)
                    },
                    {
                        path: 'movement',
                        loadChildren: () => import( './general-reports/movement/movement.module').then(m => m.MovementModule)
                    },
                ],
            }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AuthenticatedRoutingModule {
}
